import createIcon from '../../createIcon';

/**
 * @component @name SpatialAudioOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDE0QzExLjcwOTEgMTQgMTMuNSAxMi4yMDkxIDEzLjUgMTBDMTMuNSA3Ljc5MDg2IDExLjcwOTEgNiA5LjUgNkM3LjI5MDg2IDYgNS41IDcuNzkwODYgNS41IDEwQzUuNSAxMi4yMDkxIDcuMjkwODYgMTQgOS41IDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1Ljg5IDE2LjU2QzE0LjIxIDE1LjcgMTIuMDMgMTUgOS41IDE1QzYuOTcgMTUgNC43OSAxNS43IDMuMTEgMTYuNTZDMi4xMSAxNy4wNyAxLjUgMTguMSAxLjUgMTkuMjJWMjJIMTcuNVYxOS4yMkMxNy41IDE4LjEgMTYuODkgMTcuMDcgMTUuODkgMTYuNTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkuODYgMkwxOC40NSAzLjQxQzIxLjE4IDYuMTQgMjEuMTggMTAuNTggMTguNDUgMTMuMzFMMTkuODYgMTQuNzJDMjMuMzggMTEuMjEgMjMuMzggNS41MSAxOS44NiAyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3LjA0IDExLjlDMTguOTkgOS45NSAxOC45OSA2Ljc4IDE3LjA0IDQuODNMMTUuNjMgNi4yNEMxNi44IDcuNDEgMTYuOCA5LjMxIDE1LjYzIDEwLjQ4TDE3LjA0IDExLjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpatialAudioOff = createIcon('SpatialAudioOff', [
  [
    'path',
    {
      d: 'M9.5 14C11.7091 14 13.5 12.2091 13.5 10C13.5 7.79086 11.7091 6 9.5 6C7.29086 6 5.5 7.79086 5.5 10C5.5 12.2091 7.29086 14 9.5 14Z',
      key: '1gcv8w',
    },
  ],
  [
    'path',
    {
      d: 'M15.89 16.56C14.21 15.7 12.03 15 9.5 15C6.97 15 4.79 15.7 3.11 16.56C2.11 17.07 1.5 18.1 1.5 19.22V22H17.5V19.22C17.5 18.1 16.89 17.07 15.89 16.56Z',
      key: '133srz',
    },
  ],
  [
    'path',
    {
      d: 'M19.86 2L18.45 3.41C21.18 6.14 21.18 10.58 18.45 13.31L19.86 14.72C23.38 11.21 23.38 5.51 19.86 2Z',
      key: '2sflji',
    },
  ],
  [
    'path',
    {
      d: 'M17.04 11.9C18.99 9.95 18.99 6.78 17.04 4.83L15.63 6.24C16.8 7.41 16.8 9.31 15.63 10.48L17.04 11.9Z',
      key: 'ez62nq',
    },
  ],
]);

export default SpatialAudioOff;
